import { render, staticRenderFns } from "./EducationProofOfTrainingPreview.vue?vue&type=template&id=13b59732&scoped=true"
import script from "./EducationProofOfTrainingPreview.vue?vue&type=script&lang=ts"
export * from "./EducationProofOfTrainingPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b59732",
  null
  
)

export default component.exports